module.exports = __webpack_public_path__ + "img/67_11.6db186eb.png";